import type { ElevatorRidePresentation } from "../sim/elevators/index.ts";

export interface ElevatorUi {
  update(presentation: Readonly<ElevatorRidePresentation> | null): void;
  dispose(): void;
}

export function createElevatorUi(root: HTMLElement): ElevatorUi {
  const overlay = document.createElement("section");
  overlay.className = "elevator-ride";
  overlay.hidden = true;
  overlay.setAttribute("aria-live", "polite");
  overlay.setAttribute("aria-atomic", "true");

  const panel = document.createElement("div");
  panel.className = "elevator-ride__panel";
  const eyebrow = document.createElement("p");
  eyebrow.className = "elevator-ride__eyebrow";
  const levels = document.createElement("p");
  levels.className = "elevator-ride__levels";
  const destination = document.createElement("p");
  destination.className = "elevator-ride__destination";
  const progress = document.createElement("div");
  progress.className = "elevator-ride__progress";
  const progressFill = document.createElement("div");
  progressFill.className = "elevator-ride__progress-fill";
  progress.append(progressFill);
  panel.append(eyebrow, levels, destination, progress);
  overlay.append(panel);
  root.append(overlay);

  return {
    update(presentation): void {
      overlay.hidden = presentation === null;
      if (presentation === null) return;
      const progress01 = Math.max(0, Math.min(1, presentation.progress01));
      const maskOpacity = Math.sin(progress01 * Math.PI);
      overlay.style.setProperty("--elevator-mask", maskOpacity.toFixed(3));
      overlay.style.setProperty(
        "--elevator-progress",
        `${(progress01 * 100).toFixed(1)}%`,
      );
      eyebrow.textContent = presentation.elevatorLabel;
      levels.textContent = `${presentation.fromLevelLabel}  /  ${presentation.toLevelLabel}`;
      destination.textContent = `Travelling to ${presentation.toLabel}`;
    },
    dispose(): void {
      overlay.remove();
    },
  };
}
